<script setup lang="ts">
    import { computed } from 'vue';

    const props = withDefaults(
        defineProps<{
            value?: string | string[];
            separator?: string;
            size?: 'sm' | 'md' | 'lg';
        }>(),
        {
            separator: ', ',
            size: 'lg',
        },
    );

    const sizes = {
        sm: 'max-w-[100px] lg:max-w-sm',
        md: 'max-w-[150px] lg:max-w-md',
        lg: 'max-w-xs lg:max-w-xl xl:max-w-4xl',
    };

    const displayText = computed(() => {
        return Array.isArray(props.value) ? props.value.join(props.separator) : props.value;
    });
</script>

<template>
    <div
        class="truncate"
        :class="sizes[size]"
        :title="displayText"
    >
        {{ displayText }}
    </div>
</template>
